import * as THREE from "three";

export interface MatOpts { r?: number; m?: number; x?: THREE.MeshStandardMaterialParameters }

export const M = (c: THREE.ColorRepresentation, o: MatOpts = {}) =>
  new THREE.MeshStandardMaterial({ color: c, roughness: o.r ?? 0.85, metalness: o.m ?? 0, ...o.x });

export const mat = {
  facade: M(0xcfdca4), facadeN: M(0xe8b37a), wall: M(0xf3f1ec), base: M(0x9d9c95),
  slab: M(0xf7f6f2), fUG: M(0xbdb8ae), fEG: M(0xc9a272, { r: 0.7 }), fOG: M(0xc59d6c, { r: 0.7 }), fDG: M(0xd5b98f, { r: 0.7 }),
  roof: M(0x34373a, { r: 0.85 }), roofN: M(0x74645a, { r: 0.9 }), frame: M(0xfafafa, { r: 0.5 }), jamb: M(0xe7e1d6, { r: 0.6 }),
  glass: new THREE.MeshStandardMaterial({ color: 0xa9c6d6, roughness: 0.05, metalness: 0.1, transparent: true, opacity: 0.28, depthWrite: false }),
  gblock: new THREE.MeshStandardMaterial({ color: 0xcfe3ec, roughness: 0.3, transparent: true, opacity: 0.7 }),
  stair: M(0x9b6c46, { r: 0.6 }), chimney: M(0x7b6a5e), gate: M(0x3a2e29, { r: 0.6 }), door: M(0x3b3836, { r: 0.5 }),
  grass: M(0x82a35c, { r: 1 }), soil: M(0x7a5d44, { r: 1 }), paving: M(0xb8b2a6, { r: 0.95 }), asphalt: M(0x6d6f71, { r: 1 }),
  curb: M(0xc9c5bc), wood: M(0x8a6648, { r: 0.8 }), woodDark: M(0x4a3a30, { r: 0.8 }), metal: M(0x8e9396, { r: 0.4, m: 0.5 }),
  steel: M(0xc3c7ca, { r: 0.3, m: 0.6 }), white: M(0xf5f5f2, { r: 0.5 }), black: M(0x232527, { r: 0.5 }),
  pergolaGlass: new THREE.MeshStandardMaterial({ color: 0xdfe8e4, roughness: 0.2, transparent: true, opacity: 0.35, depthWrite: false, side: THREE.DoubleSide }),
  grate: M(0x55595b, { r: 0.6, m: 0.4 }),
};
export type MatName = keyof typeof mat;
